import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

type OrganisationId = string | null | undefined;

type SamlPayload = {
  enabled?: boolean;
  default_login_enabled?: boolean;
  identity_provider: {
    login_url?: string;
    logout_url?: string;
    entity_id?: string;
    certificate?: string;
    attributes?: { attr_claim?: string };
  };
  service_provider: {
    entity_id?: string;
    consumer_url?: string;
    logout_url?: string;
  };
};

type SamlSender = {
  uuid: OrganisationId;
  data?: SamlPayload;
};

export const useSsoStore = defineStore("sso", () => {
  const buildRequestBody = (data?: SamlPayload) => ({
    enabled: data?.enabled,
    default_login_enabled: data?.default_login_enabled,
    identity_provider: {
      login_url: data?.identity_provider.login_url,
      logout_url: data?.identity_provider.logout_url,
      entity_id: data?.identity_provider.entity_id,
      certificate: btoa(data?.identity_provider.certificate || ""),
      attributes: {
        email: data?.identity_provider.attributes?.attr_claim,
      },
    },
    service_provider: {
      entity_id: data?.service_provider.entity_id,
      consumer_url: data?.service_provider.consumer_url,
      logout_url: data?.service_provider.logout_url,
    },
  });

  const ssoConfiEnabled = async ({ uuid }: { uuid: OrganisationId }) => {
    const ssoSaml = await $http.get(
      `${getApiClientUrl()}/v1/idp/organisations/${uuid}/sso/saml/enabled`,
    );

    return ssoSaml.data;
  };

  const showSSOconfig = async ({ uuid }: { uuid: OrganisationId }) => {
    const ssoSaml = await $http.get(
      `${getApiClientUrl()}/v1/idp/organisations/${uuid}/sso/saml`,
    );
    const response = ssoSaml.data.data.identity_provider;
    response.default_login_enabled = ssoSaml.data.data.default_login_enabled;

    return response;
  };

  const updateSamlSSO = async ({ uuid, data }: SamlSender) => {
    const updateSsoSaml = await $http.patch(
      `${getApiClientUrl()}/v1/idp/organisations/${uuid}/sso/saml`,
      buildRequestBody(data),
    );

    return updateSsoSaml;
  };

  const createSamlSSO = async ({ uuid, data }: SamlSender) => {
    const ssoSaml = await $http.post(
      `${getApiClientUrl()}/v1/idp/organisations/${uuid}/sso/saml`,
      buildRequestBody(data),
    );

    return ssoSaml;
  };

  return {
    ssoConfiEnabled,
    showSSOconfig,
    updateSamlSSO,
    createSamlSSO,
  };
});
